// extracted by mini-css-extract-plugin
export default {"emoji":"styles_emoji__Fmw5Q"};